import { IDateRange } from '../../components/atoms/calendar-date-ranger-picker/IDateRange';

export interface QueryData<T,U,S> {
  status?: T;
  type?: U;
  subtype?: S;
  createdOnDate: IDateRange;
  interactedOnDate: IDateRange;
  searchTerm?: string;
  additionalData?: any;
}
